import React from "react";
import Layout from "layout";
import Profile from "./Profile";

const ProfilePage = () => {
  return (
    <Layout>
      <Profile />
    </Layout>
  );
};

export default ProfilePage;
